enum configs {
  "paginationSize" = 50,
  "sessionTimeout" = 85,
  "studentSessionTimeout" = 27
}

export const defaultGradeLevels: string[] = ["K", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
export const defaultGradeLevelIds: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const paginationControllers = [500, 250, 100, 50];

export const classLimit: number = 2000;

export default configs;
